<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Collection';
                }
            },
            component_id: {
                default(){
                    return 'collection';
                }
            },
            question: {
                required: true,
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/collection?question=' + this.question;
            },
            cache_key(){
                return '_' + this.question;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
